import { render, staticRenderFns } from "./BlockTagsAdd.vue?vue&type=template&id=f8c6c072&"
import script from "./BlockTagsAdd.vue?vue&type=script&lang=ts&"
export * from "./BlockTagsAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports